export default __webpack_public_path__ + "static/media/lightning.8908c2db.webp";